/**
 * Обёртка над BPS-редьюсером: при получении model_meta сохраняет required_fields из ответа
 * (ядро не трогаем, required_fields нужны только для иконки обязательных полей в СИГУР).
 */
export function withRequiredFields(projectName, baseReducer) {
  return (state, action) => {
    const nextState = baseReducer(state, action)
    if (
      action.type === `${projectName}_model_meta` &&
      action.data &&
      action.data.required_fields !== undefined
    ) {
      return { ...nextState, required_fields: action.data.required_fields }
    }
    return nextState
  }
}
